import { useEffect, useState } from "react";
import api from "@/lib/api";

export const SITE_URL = String(process.env.REACT_APP_SITE_URL).replace(/\/$/, "");

// Datos de la web pública: vienen ya en el HTML prerenderizado (window.__SEO__) y se refrescan desde la API.
const inicial = () => (typeof window !== "undefined" && window.__SEO__) || null;
let promesa = null;

// Si la API falla se usan los textos base incluidos en la app (se descargan solo en ese caso).
const respaldo = () => import("./datos-base.json").then((m) => m.default || m);

export function cargarDatos() {
  if (!promesa) promesa = api.get("/seo/publico").then((r) => r.data).catch(() => respaldo().then((r) => ({ ...r, respaldo: true }))).catch((e) => { promesa = null; throw e; });
  return promesa;
}

export function useDatosSeo() {
  const [d, setD] = useState(inicial);
  useEffect(() => {
    let vivo = true;
    // Con datos pregenerados no hace falta esperar: se refrescan en segundo plano; sin ellos, API o respaldo.
    cargarDatos().then((n) => vivo && setD((v) => ({ ...n, articulo: v?.articulo }))).catch(() => {});
    return () => { vivo = false; };
  }, []);
  return d;
}

// «/precios/» es la misma página que «/precios» (canonical y contenido sin barra final).
export const rutaLimpia = (ruta) => String(ruta || "/").replace(/\/+$/, "") || "/";
export const paginaDe = (d, ruta) => d?.paginas?.find((p) => p.ruta === rutaLimpia(ruta));

export const fechaLarga = (iso) => (iso ? new Date(`${String(iso).slice(0, 10)}T12:00:00Z`).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" }) : "");
